// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rm-c";
export var backButton = "_rm-4";
export var backIcon = "_rm-5";
export var chevronShortcut = "_rm-6";
export var container = "_rm-1";
export var editor = "_rm-8";
export var editorWrapper = "_rm-7";
export var prefix = "_rm-2";
export var searchIcon = "_rm-3";
export var suffix = "_rm-9";
export var suffixContent = "_rm-a";
export var suffixText = "_rm-b";
export var wrapper = "_rm-0";